import styles from '../index.less';

const FilterList = ({ data = [], onChange, value }) => {
  return (
    <ul className={styles.filterOptions}>
      {data.map(item => (
        <li
          key={item.value}
          onClick={() => onChange(item.value)}
          className={item.value === value ? styles.active : ''}
        >
          {item.label}
        </li>
      ))}
    </ul>
  );
};
export default FilterList;
